export const MENU_ITEMS = {
    PROFILE: 'menu.profile',
    CAMPAIGNS: 'menu.campaigns',
    LOGOUT: 'menu.logout',
    LOGIN: 'menu.login',
};
